import { gql } from "@apollo/client";

export default gql`
  query getMigrationLatestRuns{
    getMigrationLatestRuns{
        success
        data{
            _id
            type
            status
            succeeded
            startedAt
            finishedAt
            durationMs
            heartbeatAt
            countsBefore
            countsAfter
            result
            error
        }
        code
        message
    }
}
`
